import { isKeyOfObject } from '@/utils/functions/helpers/isKeyOfObject'

export function getShallowDiffBetweenObjects<T extends object>(
  baseObject: T,
  comparingObject: T,
): Partial<T> {
  let difference: Partial<T> = {}

  Object.keys(baseObject).forEach((key) => {
    if (!isKeyOfObject(key, baseObject) || !isKeyOfObject(key, comparingObject)) return

    if (JSON.stringify(baseObject[key]) !== JSON.stringify(comparingObject[key])) {
      difference = {
        ...difference,
        [key]: comparingObject[key],
      }
    }
  })

  return difference
}
